import React, { useState, useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import Swal from "sweetalert2";
import LayersIcon from '@mui/icons-material/Layers';
import ScienceIcon from '@mui/icons-material/Science';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import CloseIcon from '@mui/icons-material/Close';
import LocalBarIcon from '@mui/icons-material/LocalBar';

const EnvasadoNoTerminadoSection = ({
  noTerminadoRecords,
  granelRecords = [],
  isFormOpen,
  setIsFormOpen,
  fechaMovimiento,
  setFechaMovimiento,
  botCaja,
  setBotCaja,
  marca,
  setMarca,
  noLoteGranel,
  setNoLoteGranel,
  volumenEnvasar,
  setVolumenEnvasar,
  noInformeAprobacion,
  setNoInformeAprobacion,
  loteEnvasado,
  setLoteEnvasado,
  categoria,
  setCategoria,
  clase,
  setClase,
  ingrediente,
  setIngrediente,
  edad,
  setEdad,
  tipoMaguey,
  setTipoMaguey,
  noAnalisis,
  setNoAnalisis,
  capacidad,
  setCapacidad,
  pctAlc,
  setPctAlc,
  invInicialCajas,
  setInvInicialCajas,
  invInicialBotellas,
  setInvInicialBotellas,
  entradaProcedencia,
  setEntradaProcedencia,
  entradaCajas,
  setEntradaCajas,
  entradaBotellas,
  setEntradaBotellas,
  salidaCajas,
  setSalidaCajas,
  salidaBotellas,
  setSalidaBotellas,
  salidaDestino,
  setSalidaDestino,
  invFinalCajas,
  setInvFinalCajas,
  invFinalBotellas,
  setInvFinalBotellas,
  mermas,
  setMermas,
  observaciones,
  setObservaciones,
  handleSaveNoTerminado,
  onCompleteEnvasado,
  onSaveHologramas
}) => {
  // MODAL 1: TERMINAR ENVASADO (SECCIÓN IV - IMÁGENES 2 Y 3)
  const [isTerminarModalOpen, setIsTerminarModalOpen] = useState(false);
  const [selectedRecordForTerminar, setSelectedRecordForTerminar] = useState(null);

  // Form states for Terminar Modal (Imágenes 2 y 3)
  const [tNoInformeAprobacion, setTNoInformeAprobacion] = useState("INF-APR-ET-102");
  const [tFechaAprobacionEtiqueta, setTFechaAprobacionEtiqueta] = useState("2026-07-17");
  const [tClaseEtiqueta, setTClaseEtiqueta] = useState("Joven / Blanco");
  const [tIngredientesEtiqueta, setTIngredientesEtiqueta] = useState("Maguey Espadín");
  const [tTipoMagueyEtiqueta, setTTipoMagueyEtiqueta] = useState("Espadín");
  const [tPctAlcEtiqueta, setTPctAlcEtiqueta] = useState("48.5");
  const [tInvInicialCajas, setTInvInicialCajas] = useState("5");
  const [tInvInicialBotellas, setTInvInicialBotellas] = useState("60");
  const [tEntradaProcedencia, setTEntradaProcedencia] = useState("Etiquetado Lote NT-01");
  const [tEntradaCajas, setTEntradaCajas] = useState("15");
  const [tEntradaBotellas, setTEntradaBotellas] = useState("180");
  const [tSalidaDestino, setTSalidaDestino] = useState("Almacén de Producto Terminado");
  const [tSalidaCajas, setTSalidaCajas] = useState("10");
  const [tSalidaBotellas, setTSalidaBotellas] = useState("120");
  const [tObservaciones, setTObservaciones] = useState("Proceso de etiquetado completado y verificado.");

  // MODAL 2: CONTROL DE HOLOGRAMAS (SECCIÓN V - IMAGEN 4)
  const [isHologramasModalOpen, setIsHologramasModalOpen] = useState(false);
  const [selectedRecordForHologramas, setSelectedRecordForHologramas] = useState(null);

  // Form states for Hologramas Modal (Imagen 4)
  const [hInvInicialRango, setHInvInicialRango] = useState("A0123 - A0500");
  const [hInvInicialCant, setHInvInicialCant] = useState("378");
  const [hEntradaRango, setHEntradaRango] = useState("B0001 - B0500");
  const [hEntradaCant, setHEntradaCant] = useState("500");
  const [hSalidaRango, setHSalidaRango] = useState("A0123 - A0223");
  const [hSalidaCant, setHSalidaCant] = useState("101");
  const [hMermasRango, setHMermasRango] = useState("N/A");
  const [hMermasCant, setHMermasCant] = useState("0");
  const [hObservaciones, setHObservaciones] = useState("Hologramas aplicados e inventario actualizado.");

  // Handlers for opening modals
  const handleOpenTerminarModal = (rec) => {
    setSelectedRecordForTerminar(rec);
    setTClaseEtiqueta(rec.clase || "Joven / Blanco");
    setTIngredientesEtiqueta(rec.ingrediente || "Maguey Espadín");
    setTTipoMagueyEtiqueta(rec.tipoMaguey || "Espadín");
    setTPctAlcEtiqueta(rec.pctAlc || "48.5");
    setTEntradaProcedencia(`Etiquetado de lote ${rec.loteEnvasado}`);
    setIsTerminarModalOpen(true);
  };

  const handleConfirmTerminar = () => {
    if (!selectedRecordForTerminar) return;

    const initC = parseInt(tInvInicialCajas || 0, 10);
    const initB = parseInt(tInvInicialBotellas || 0, 10);
    const entC = parseInt(tEntradaCajas || 0, 10);
    const entB = parseInt(tEntradaBotellas || 0, 10);
    const salC = parseInt(tSalidaCajas || 0, 10);
    const salB = parseInt(tSalidaBotellas || 0, 10);

    const invFinalCajasCalc = Math.max(0, (initC + entC) - salC);
    const invFinalBotellasCalc = Math.max(0, (initB + entB) - salB);

    const finishedData = {
      noInformeAprobacion: tNoInformeAprobacion,
      fechaAprobacionEtiqueta: tFechaAprobacionEtiqueta,
      claseEtiqueta: tClaseEtiqueta,
      ingredientesEtiqueta: tIngredientesEtiqueta,
      tipoMagueyEtiqueta: tTipoMagueyEtiqueta,
      pctAlcEtiqueta: tPctAlcEtiqueta,
      invInicialCajas: tInvInicialCajas,
      invInicialBotellas: tInvInicialBotellas,
      entradaProcedencia: tEntradaProcedencia,
      entradaCajas: tEntradaCajas,
      entradaBotellas: tEntradaBotellas,
      salidaDestino: tSalidaDestino,
      salidaCajas: tSalidaCajas,
      salidaBotellas: tSalidaBotellas,
      invFinalCajas: invFinalCajasCalc.toString(),
      invFinalBotellas: invFinalBotellasCalc.toString(),
      observaciones: tObservaciones
    };

    if (onCompleteEnvasado) {
      onCompleteEnvasado(selectedRecordForTerminar, finishedData);
    }
    setIsTerminarModalOpen(false);
    alert(`¡Lote ${selectedRecordForTerminar.loteEnvasado} finalizado y registrado como Envasado Terminado (Sección IV)!`);
  };

  const handleOpenHologramasModal = (rec) => {
    setSelectedRecordForHologramas(rec);
    setIsHologramasModalOpen(true);
  };

  const handleConfirmHologramas = () => {
    if (!selectedRecordForHologramas) return;

    const initC = parseInt(hInvInicialCant || 0, 10);
    const entC = parseInt(hEntradaCant || 0, 10);
    const salC = parseInt(hSalidaCant || 0, 10);
    const merC = parseInt(hMermasCant || 0, 10);
    const finalCantCalc = Math.max(0, (initC + entC) - salC - merC);

    const hologramData = {
      invInicialRango: hInvInicialRango,
      invInicialCant: hInvInicialCant,
      entradaRango: hEntradaRango,
      entradaCant: hEntradaCant,
      salidaRango: hSalidaRango,
      salidaCant: hSalidaCant,
      mermasRango: hMermasRango,
      mermasCant: hMermasCant,
      invFinalRango: `A0224 - A0500, B0001 - B0500`,
      invFinalCant: finalCantCalc.toString(),
      observaciones: hObservaciones
    };

    if (onSaveHologramas) {
      onSaveHologramas(selectedRecordForHologramas, hologramData);
    }
    setIsHologramasModalOpen(false);
    alert(`¡Control de Hologramas asignado exitosamente al lote ${selectedRecordForHologramas.loteEnvasado} (Sección V)!`);
  };

  // Local fallbacks para volumen a envasar e informe de aprobación
  const [localVolumenEnvasar, setLocalVolumenEnvasar] = useState("750");
  const currentVolumenEnvasar = volumenEnvasar !== undefined ? volumenEnvasar : localVolumenEnvasar;
  const handleSetVolumenEnvasar = setVolumenEnvasar || setLocalVolumenEnvasar;

  const [localNoInformeAprobacion, setLocalNoInformeAprobacion] = useState("INF-APR-ET-102");
  const currentNoInformeAprobacion = noInformeAprobacion !== undefined ? noInformeAprobacion : localNoInformeAprobacion;
  const handleSetNoInformeAprobacion = setNoInformeAprobacion || setLocalNoInformeAprobacion;

  // Convertir capacidad/presentación a Litros
  const parseCapacityInLiters = (capStr) => {
    if (!capStr) return 0.75;
    const str = String(capStr).trim().toLowerCase();
    if (str.includes("ml")) {
      const n = parseFloat(str.replace(/[^0-9.]/g, ""));
      return n > 0 ? n / 1000 : 0.75;
    }
    if (str.includes("l")) {
      const n = parseFloat(str.replace(/[^0-9.]/g, ""));
      return n > 0 ? n : 0.75;
    }
    const n = parseFloat(str);
    if (isNaN(n) || n <= 0) return 0.75;
    return n > 10 ? n / 1000 : n;
  };

  // Buscar el registro de lote a granel seleccionado
  const selectedGranel = useMemo(() => {
    if (!noLoteGranel || noLoteGranel === "manual") return null;
    return (granelRecords || []).find(r => 
      r.noLote === noLoteGranel || 
      r.no_lote === noLoteGranel || 
      String(r.id) === String(noLoteGranel) ||
      String(r.noProduccion) === String(noLoteGranel)
    );
  }, [noLoteGranel, granelRecords]);

  // Manejador al seleccionar un lote a granel: auto-completar y desplegar características
  const handleSelectGranel = (loteVal) => {
    if (setNoLoteGranel) setNoLoteGranel(loteVal);
    if (!loteVal || loteVal === "manual") return;

    const found = (granelRecords || []).find(r => 
      r.noLote === loteVal || 
      r.no_lote === loteVal || 
      String(r.id) === String(loteVal) ||
      String(r.noProduccion) === String(loteVal)
    );

    if (found) {
      if (found.categoria && setCategoria) setCategoria(found.categoria);
      if (found.clase && setClase) setClase(found.clase);
      const maguey = found.tipoMaguey || found.especie || found.materiaPrima || found.tipo_maguey || "";
      if (maguey && setTipoMaguey) setTipoMaguey(maguey);
      const fq = found.noAnalisis || found.clave_fq || found.noAnalisisFisicoquimico || found.no_analisis || "";
      if (fq && fq !== "-" && setNoAnalisis) setNoAnalisis(fq);
      const alc = found.invFinalAlc || found.porcentaje_alc_vol || found.alcFinal || found.entradaAlc || "";
      if (alc && setPctAlc) setPctAlc(String(alc));
      const ing = found.ingrediente || found.ingredientes || (maguey ? `100% ${maguey}` : "");
      if (ing && setIngrediente) setIngrediente(ing);
      if (found.edad && setEdad) setEdad(found.edad);

      // Si hay volumen disponible en el granel, sugerir volumen a envasar si no se ha definido
      const volDisp = found.invFinalVol || found.litros || "";
      if (volDisp && (!currentVolumenEnvasar || currentVolumenEnvasar === "0")) {
        handleSetVolumenEnvasar(String(volDisp));
      }
    }
  };

  // Cálculo automático de entradas número de botellas: volumen a envasar / presentación
  useEffect(() => {
    const volNum = parseFloat(currentVolumenEnvasar);
    const presLitros = parseCapacityInLiters(capacidad);
    if (!isNaN(volNum) && volNum > 0 && presLitros > 0) {
      const botellasCalculadas = Math.round(volNum / presLitros);
      if (setEntradaBotellas) {
        setEntradaBotellas(botellasCalculadas.toString());
      }
      const bCaja = parseInt(String(botCaja).replace(/[^0-9]/g, ""), 10) || 12;
      if (bCaja > 0 && setEntradaCajas) {
        const cajasCalculadas = Math.floor(botellasCalculadas / bCaja);
        setEntradaCajas(cajasCalculadas.toString());
      }
    }
  }, [currentVolumenEnvasar, capacidad, botCaja, setEntradaBotellas, setEntradaCajas]);

  // Calculations for main form
  const initCajasNum = parseInt(invInicialCajas || 0, 10);
  const initBotNum = parseInt(invInicialBotellas || 0, 10);
  const entCajasNum = parseInt(entradaCajas || 0, 10);
  const entBotNum = parseInt(entradaBotellas || 0, 10);
  const salCajasNum = parseInt(salidaCajas || 0, 10);
  const salBotNum = parseInt(salidaBotellas || 0, 10);

  const calcFinalCajas = Math.max(0, (initCajasNum + entCajasNum) - salCajasNum);
  const calcFinalBotellas = Math.max(0, (initBotNum + entBotNum) - salBotNum);

  // Siempre mostrar la tabla y abrir formulario en Modal

    return (
      <div className="animate-fadeIn">
        <div className="history-section-header">
          <div>
            <h2>Inventarios de Mezcal Envasado "No Terminado" (Sección III)</h2>
            <p style={{ margin: 0, color: "var(--text-muted)", fontSize: "13px" }}>
              Botella desnuda / sin etiquetar. Desde la tabla puede <strong>Terminar Envasado</strong> (Sección IV) o asignar <strong>Hologramas</strong> (Sección V).
            </p>
          </div>
          <button
            onClick={() => setIsFormOpen(true)}
            className="btn-add-new"
          >
            <AddIcon style={{ fontSize: 18 }} />
            <span>Registro de envasado de producto</span>
          </button>
        </div>

        <div className="records-list-wrapper">
          <table className="records-table">
            <thead>
              <tr>
                <th colSpan="7" style={{ textAlign: "center", background: "rgba(74, 93, 35, 0.2)", color: "var(--agave-green)" }}>Datos Generales / Identificación del Mezcal</th>
                <th colSpan="3" style={{ textAlign: "center", background: "rgba(155, 89, 182, 0.2)", color: "#d5a6bd" }}>Trazabilidad & Acciones</th>
              </tr>
              <tr>
                {/* Identificación */}
                <th>Fecha Mov.</th>
                <th>Bot/Caja</th>
                <th>Marca</th>
                <th>Lote Granel</th>
                <th>Lote Env.</th>
                <th>Categoría</th>
                <th>Clase</th>

                {/* Cierre y Acciones */}
                <th>Etapa Proceso</th>
                <th>Estatus COMERCAM</th>
                <th style={{ minWidth: "220px", textAlign: "center" }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {noTerminadoRecords.map((rec, i) => {
                const stage = rec.estadoProceso || "no_terminado";
                return (
                  <tr key={i}>
                    <td>{rec.fechaMovimiento}</td>
                    <td>{rec.botCaja}</td>
                    <td style={{ fontWeight: 800 }}>{rec.marca}</td>
                    <td>{rec.noLoteGranel}</td>
                    <td style={{ color: "var(--copper)", fontWeight: 700 }}>{rec.loteEnvasado}</td>
                    <td>{rec.categoria}</td>
                    <td>{rec.clase}</td>

                    <td>
                      <span className={`badge-stage ${stage}`}>
                        {stage === "hologramado" ? "🟢 Hologramado" : stage === "terminado" ? "🔵 Terminado" : "🟡 No Terminado"}
                      </span>
                    </td>
                    <td>
                      <span className={`badge-status ${rec.status}`}>
                        {rec.status === "aprobado" ? "Aprobado" : rec.status === "revision" ? "En revisión" : "Borrador"}
                      </span>
                    </td>
                    <td>
                      <div style={{ display: "flex", gap: "6px", justifyContent: "center" }}>
                        <button
                          onClick={() => handleOpenTerminarModal(rec)}
                          style={{
                            background: "linear-gradient(135deg, #d2691e 0%, #b85c14 100%)",
                            border: "none",
                            color: "#fff",
                            borderRadius: "6px",
                            padding: "6px 10px",
                            fontSize: "11px",
                            fontWeight: 700,
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px"
                          }}
                          title="Terminar Envasado (Asignar Etiqueta Aprobada - Imagen 2 y 3)"
                        >
                          <WorkspacePremiumIcon style={{ fontSize: 14 }} />
                          <span>Terminar</span>
                        </button>

                        <button
                          onClick={() => handleOpenHologramasModal(rec)}
                          style={{
                            background: "linear-gradient(135deg, #8e44ad 0%, #732d91 100%)",
                            border: "none",
                            color: "#fff",
                            borderRadius: "6px",
                            padding: "6px 10px",
                            fontSize: "11px",
                            fontWeight: 700,
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px"
                          }}
                          title="Control de Hologramas (Sección V - Imagen 4)"
                        >
                          <ConfirmationNumberIcon style={{ fontSize: 14 }} />
                          <span>Hologramas</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* MODAL 1: TERMINAR ENVASADO (SECCIÓN IV - IMÁGENES 2 Y 3) */}
        {isTerminarModalOpen && selectedRecordForTerminar && createPortal(
          <div className="modal-backdrop-custom animate-fadeIn" onClick={() => setIsTerminarModalOpen(false)}>
            <div
              className="detail-modal-card animate-fadeIn"
              onClick={(e) => e.stopPropagation()}
              style={{ maxWidth: "850px", maxHeight: "90vh", display: "flex", flexDirection: "column" }}
            >
              {/* Header del Modal */}
              <div className="detail-modal-header" style={{ background: "linear-gradient(135deg, #C2410C 0%, #EA580C 100%)", color: "white", padding: "16px 22px" }}>
                <div className="detail-modal-title-box">
                  <div className="detail-modal-badge-row" style={{ marginBottom: "4px" }}>
                    <span className="badge-modal-tag" style={{ background: "rgba(255,255,255,0.2)", color: "white" }}>
                      ACREDITACIÓN & REGISTRO
                    </span>
                    <span className="badge-status enviada" style={{ background: "rgba(255,255,255,0.25)", color: "#FFFFFF" }}>
                      SECCIÓN IV: ENVASADO TERMINADO
                    </span>
                  </div>
                  <h1 className="detail-modal-title" style={{ color: "white", fontSize: "19px", margin: 0 }}>
                    Terminar Envasado - Aprobación de Etiqueta
                  </h1>
                  <div style={{ color: "rgba(255,255,255,0.85)", fontSize: "12px", marginTop: "3px" }}>
                    Lote: <strong>{selectedRecordForTerminar.loteEnvasado}</strong> | Granel: {selectedRecordForTerminar.noLoteGranel} | Marca: {selectedRecordForTerminar.marca}
                  </div>
                </div>

                <button
                  type="button"
                  onClick={() => setIsTerminarModalOpen(false)}
                  className="detail-modal-close-btn"
                  title="Cerrar ventana"
                >
                  <CloseIcon />
                </button>
              </div>

              {/* Body del Modal */}
              <div
                className="detail-modal-body"
                style={{ padding: "20px 24px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "16px", background: "#F8FAFC" }}
              >
                {/* 1. APROBACIÓN DE ETIQUETA (IMAGEN 2) */}
                <div className="modal-section-card">
                  <div className="modal-section-header">
                    <div className="modal-section-icon" style={{ background: "rgba(194, 65, 12, 0.1)", color: "#C2410C" }}>
                      <WorkspacePremiumIcon style={{ fontSize: 22 }} />
                    </div>
                    <div className="modal-section-title-wrap">
                      <h3>1. Aprobación de Etiqueta (Imagen 2)</h3>
                      <p>Datos del dictamen de etiqueta e inventario inicial</p>
                    </div>
                  </div>

                  <div className="species-grid">
                    <div className="custom-input-group">
                      <label className="custom-input-label">Nº Informe de Aprobación de Etiqueta</label>
                      <input
                        type="text"
                        value={tNoInformeAprobacion}
                        onChange={e => setTNoInformeAprobacion(e.target.value)}
                        className="custom-input-field"
                        placeholder="Ej. INF-APR-ET-102"
                      />
                    </div>

                    <div className="custom-input-group">
                      <label className="custom-input-label">Fecha de Aprobación</label>
                      <input
                        type="date"
                        value={tFechaAprobacionEtiqueta}
                        onChange={e => setTFechaAprobacionEtiqueta(e.target.value)}
                        className="custom-input-field"
                      />
                    </div>
                  </div>

                  <div className="species-grid" style={{ marginBottom: 0 }}>
                    <div className="custom-input-group">
                      <label className="custom-input-label">Cajas Iniciales</label>
                      <input
                        type="number"
                        value={tInvInicialCajas}
                        onChange={e => setTInvInicialCajas(e.target.value)}
                        className="custom-input-field"
                      />
                    </div>

                    <div className="custom-input-group">
                      <label className="custom-input-label">Botellas Iniciales</label>
                      <input
                        type="number"
                        value={tInvInicialBotellas}
                        onChange={e => setTInvInicialBotellas(e.target.value)}
                        className="custom-input-field"
                      />
                    </div>
                  </div>
                </div>

                {/* 2. ENTRADAS, SALIDAS Y BALANCES (IMAGEN 3) */}
                <div className="modal-section-card">
                  <div className="modal-section-header">
                    <div className="modal-section-icon" style={{ background: "rgba(5, 150, 105, 0.1)", color: "#059669" }}>
                      <LayersIcon style={{ fontSize: 22 }} />
                    </div>
                    <div className="modal-section-title-wrap">
                      <h3>2. Entradas, Salidas y Saldos de Cierre (Imagen 3)</h3>
                      <p>Movimientos del lote terminado</p>
                    </div>
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "14px" }}>
                    {/* ENTRADAS */}
                    <div style={{ background: "#F1F5F9", padding: "14px", borderRadius: "10px", border: "1px solid #E2E8F0" }}>
                      <span style={{ fontSize: "11px", fontWeight: 800, color: "#059669", letterSpacing: "0.5px", display: "block", marginBottom: "10px" }}>
                        ENTRADAS
                      </span>
                      <div className="custom-input-group" style={{ marginBottom: "10px" }}>
                        <label className="custom-input-label">Procedencia Entrada</label>
                        <input
                          type="text"
                          value={tEntradaProcedencia}
                          onChange={e => setTEntradaProcedencia(e.target.value)}
                          className="custom-input-field"
                        />
                      </div>
                      <div className="species-grid" style={{ marginBottom: 0 }}>
                        <div className="custom-input-group">
                          <label className="custom-input-label">Cajas Entrada</label>
                          <input
                            type="number"
                            value={tEntradaCajas}
                            onChange={e => setTEntradaCajas(e.target.value)}
                            className="custom-input-field"
                          />
                        </div>
                        <div className="custom-input-group">
                          <label className="custom-input-label">Botellas Entrada</label>
                          <input
                            type="number"
                            value={tEntradaBotellas}
                            onChange={e => setTEntradaBotellas(e.target.value)}
                            className="custom-input-field"
                          />
                        </div>
                      </div>
                    </div>

                    {/* SALIDAS */}
                    <div style={{ background: "#F1F5F9", padding: "14px", borderRadius: "10px", border: "1px solid #E2E8F0" }}>
                      <span style={{ fontSize: "11px", fontWeight: 800, color: "#C2410C", letterSpacing: "0.5px", display: "block", marginBottom: "10px" }}>
                        SALIDAS
                      </span>
                      <div className="custom-input-group" style={{ marginBottom: "10px" }}>
                        <label className="custom-input-label">Destino Salida</label>
                        <input
                          type="text"
                          value={tSalidaDestino}
                          onChange={e => setTSalidaDestino(e.target.value)}
                          className="custom-input-field"
                        />
                      </div>
                      <div className="species-grid" style={{ marginBottom: 0 }}>
                        <div className="custom-input-group">
                          <label className="custom-input-label">Cajas Salida</label>
                          <input
                            type="number"
                            value={tSalidaCajas}
                            onChange={e => setTSalidaCajas(e.target.value)}
                            className="custom-input-field"
                          />
                        </div>
                        <div className="custom-input-group">
                          <label className="custom-input-label">Botellas Salida</label>
                          <input
                            type="number"
                            value={tSalidaBotellas}
                            onChange={e => setTSalidaBotellas(e.target.value)}
                            className="custom-input-field"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="custom-input-group">
                    <label className="custom-input-label">Observaciones generales</label>
                    <textarea
                      value={tObservaciones}
                      onChange={e => setTObservaciones(e.target.value)}
                      className="custom-textarea-field"
                      style={{ height: "65px", resize: "none" }}
                    />
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="detail-modal-footer" style={{ padding: "16px 24px", display: "flex", justifyContent: "flex-end", gap: "12px", borderTop: "1px solid #E2E8F0", background: "#FFFFFF" }}>
                <button
                  type="button"
                  onClick={() => setIsTerminarModalOpen(false)}
                  className="btn-cancel-modal"
                  style={{ padding: "10px 20px", borderRadius: "10px", border: "1px solid #CBD5E1", background: "#FFFFFF", color: "#475569", fontWeight: 700, cursor: "pointer" }}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={handleConfirmTerminar}
                  className="btn-submit-modal"
                  style={{ padding: "10px 22px", borderRadius: "10px", border: "none", background: "linear-gradient(135deg, #C2410C 0%, #EA580C 100%)", color: "#FFFFFF", fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <WorkspacePremiumIcon style={{ fontSize: 18 }} />
                  <span>Guardar Envasado Terminado (Sección IV)</span>
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}

        {/* MODAL 2: CONTROL DE HOLOGRAMAS (SECCIÓN V - IMAGEN 4) */}
        {isHologramasModalOpen && selectedRecordForHologramas && createPortal(
          <div className="modal-backdrop-custom animate-fadeIn" onClick={() => setIsHologramasModalOpen(false)}>
            <div
              className="detail-modal-card animate-fadeIn"
              onClick={(e) => e.stopPropagation()}
              style={{ maxWidth: "850px", maxHeight: "90vh", display: "flex", flexDirection: "column" }}
            >
              {/* Header del Modal */}
              <div className="detail-modal-header" style={{ background: "linear-gradient(135deg, #6B21A8 0%, #9333EA 100%)", color: "white", padding: "16px 22px" }}>
                <div className="detail-modal-title-box">
                  <div className="detail-modal-badge-row" style={{ marginBottom: "4px" }}>
                    <span className="badge-modal-tag" style={{ background: "rgba(255,255,255,0.2)", color: "white" }}>
                      CONTROL Y AUDITORÍA
                    </span>
                    <span className="badge-status enviada" style={{ background: "rgba(255,255,255,0.25)", color: "#FFFFFF" }}>
                      SECCIÓN V: CONTROL DE HOLOGRAMAS
                    </span>
                  </div>
                  <h1 className="detail-modal-title" style={{ color: "white", fontSize: "19px", margin: 0 }}>
                    Control del Inventario de Hologramas
                  </h1>
                  <div style={{ color: "rgba(255,255,255,0.85)", fontSize: "12px", marginTop: "3px" }}>
                    Asociado a Lote: <strong>{selectedRecordForHologramas.loteEnvasado}</strong> | Marca: {selectedRecordForHologramas.marca}
                  </div>
                </div>

                <button
                  type="button"
                  onClick={() => setIsHologramasModalOpen(false)}
                  className="detail-modal-close-btn"
                  title="Cerrar ventana"
                >
                  <CloseIcon />
                </button>
              </div>

              {/* Body del Modal */}
              <div
                className="detail-modal-body"
                style={{ padding: "20px 24px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "16px", background: "#F8FAFC" }}
              >
                {/* 1. RANGOS E INVENTARIO */}
                <div className="modal-section-card">
                  <div className="modal-section-header">
                    <div className="modal-section-icon" style={{ background: "rgba(107, 33, 168, 0.1)", color: "#6B21A8" }}>
                      <ConfirmationNumberIcon style={{ fontSize: 22 }} />
                    </div>
                    <div className="modal-section-title-wrap">
                      <h3>1. Inventario Inicial y Entradas de Hologramas</h3>
                      <p>Asignación de folios y saldo inicial del lote</p>
                    </div>
                  </div>

                  <div className="species-grid">
                    <div className="custom-input-group">
                      <label className="custom-input-label">Rango Inicial</label>
                      <input
                        type="text"
                        value={hInvInicialRango}
                        onChange={e => setHInvInicialRango(e.target.value)}
                        className="custom-input-field"
                        placeholder="Ej. A0123 - A0500"
                      />
                    </div>
                    <div className="custom-input-group">
                      <label className="custom-input-label">Cantidad Inicial</label>
                      <input
                        type="number"
                        value={hInvInicialCant}
                        onChange={e => setHInvInicialCant(e.target.value)}
                        className="custom-input-field"
                      />
                    </div>
                  </div>

                  <div className="species-grid" style={{ marginBottom: 0 }}>
                    <div className="custom-input-group">
                      <label className="custom-input-label">Rango Entrada (Asignación)</label>
                      <input
                        type="text"
                        value={hEntradaRango}
                        onChange={e => setHEntradaRango(e.target.value)}
                        className="custom-input-field"
                        placeholder="Ej. B0001 - B0500"
                      />
                    </div>
                    <div className="custom-input-group">
                      <label className="custom-input-label">Cantidad Entrada</label>
                      <input
                        type="number"
                        value={hEntradaCant}
                        onChange={e => setHEntradaCant(e.target.value)}
                        className="custom-input-field"
                      />
                    </div>
                  </div>
                </div>

                {/* 2. CONSUMO, MERMAS Y BALANCE */}
                <div className="modal-section-card">
                  <div className="modal-section-header">
                    <div className="modal-section-icon" style={{ background: "rgba(5, 150, 105, 0.1)", color: "#059669" }}>
                      <LayersIcon style={{ fontSize: 22 }} />
                    </div>
                    <div className="modal-section-title-wrap">
                      <h3>2. Consumo (Salidas), Mermas y Balance Final</h3>
                      <p>Registro de hologramas aplicados y mermas por daño</p>
                    </div>
                  </div>

                  <div className="species-grid">
                    <div className="custom-input-group">
                      <label className="custom-input-label">Rango Consumido (Aplicados)</label>
                      <input
                        type="text"
                        value={hSalidaRango}
                        onChange={e => setHSalidaRango(e.target.value)}
                        className="custom-input-field"
                        placeholder="Ej. A0123 - A0223"
                      />
                    </div>
                    <div className="custom-input-group">
                      <label className="custom-input-label">Cantidad Consumida</label>
                      <input
                        type="number"
                        value={hSalidaCant}
                        onChange={e => setHSalidaCant(e.target.value)}
                        className="custom-input-field"
                      />
                    </div>
                  </div>

                  <div className="species-grid">
                    <div className="custom-input-group">
                      <label className="custom-input-label">Rango Mermas (Dañados)</label>
                      <input
                        type="text"
                        value={hMermasRango}
                        onChange={e => setHMermasRango(e.target.value)}
                        className="custom-input-field"
                        placeholder="Ej. N/A o A0224 - A0225"
                      />
                    </div>
                    <div className="custom-input-group">
                      <label className="custom-input-label">Cantidad Mermada</label>
                      <input
                        type="number"
                        value={hMermasCant}
                        onChange={e => setHMermasCant(e.target.value)}
                        className="custom-input-field"
                      />
                    </div>
                  </div>

                  <div className="custom-input-group">
                    <label className="custom-input-label">Observaciones sobre hologramas</label>
                    <textarea
                      value={hObservaciones}
                      onChange={e => setHObservaciones(e.target.value)}
                      className="custom-textarea-field"
                      style={{ height: "65px", resize: "none" }}
                    />
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="detail-modal-footer" style={{ padding: "16px 24px", display: "flex", justifyContent: "flex-end", gap: "12px", borderTop: "1px solid #E2E8F0", background: "#FFFFFF" }}>
                <button
                  type="button"
                  onClick={() => setIsHologramasModalOpen(false)}
                  className="btn-cancel-modal"
                  style={{ padding: "10px 20px", borderRadius: "10px", border: "1px solid #CBD5E1", background: "#FFFFFF", color: "#475569", fontWeight: 700, cursor: "pointer" }}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={handleConfirmHologramas}
                  className="btn-submit-modal"
                  style={{ padding: "10px 22px", borderRadius: "10px", border: "none", background: "linear-gradient(135deg, #6B21A8 0%, #9333EA 100%)", color: "#FFFFFF", fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <ConfirmationNumberIcon style={{ fontSize: 18 }} />
                  <span>Guardar Control Hologramas (Sección V)</span>
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}

        {/* =========================================================================
            MODAL DE NUEVO REGISTRO DE ENVASADO NO TERMINADO (SECCIÓN III)
        ========================================================================= */}
        {isFormOpen && createPortal(
          <div className="modal-backdrop-custom animate-fadeIn" onClick={() => setIsFormOpen(false)}>
            <div
              className="detail-modal-card animate-fadeIn"
              onClick={(e) => e.stopPropagation()}
              style={{ maxWidth: "900px", maxHeight: "90vh", overflowY: "auto" }}
            >
              {/* Header del Modal */}
              <div className="detail-modal-header" style={{ background: "linear-gradient(135deg, #065F46 0%, #059669 100%)", color: "white", padding: "16px 22px" }}>
                <div className="detail-modal-title-box">
                  <div className="detail-modal-badge-row" style={{ marginBottom: "4px" }}>
                    <span className="badge-modal-tag" style={{ background: "rgba(255,255,255,0.2)", color: "white" }}>
                      NUEVO REGISTRO
                    </span>
                    <span className="badge-status enviada" style={{ background: "rgba(255,255,255,0.25)", color: "#FFFFFF" }}>
                      SECCIÓN III: ENVASADO NO TERMINADO
                    </span>
                  </div>
                  <h1 className="detail-modal-title" style={{ color: "white", fontSize: "19px" }}>
                    Registro de Envasado de Producto (Botella sin Etiquetar)
                  </h1>
                </div>

                <button
                  type="button"
                  onClick={() => setIsFormOpen(false)}
                  className="detail-modal-close-btn"
                  title="Cerrar ventana"
                  aria-label="Cerrar modal"
                >
                  <CloseIcon />
                </button>
              </div>

              {/* Formulario en Modal */}
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSaveNoTerminado("revision");
                }}
                className="detail-modal-body"
                style={{ padding: "20px 24px", display: "flex", flexDirection: "column", gap: "16px" }}
              >
        {/* PASO 1: ORIGEN A GRANEL Y VOLUMEN A ENVASAR */}
        <section className="detail-card detail-card-accent-left-green">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <LocalBarIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>1. Origen: Lote a Granel y Volumen a Envasar</h2>
              <p>Seleccione el lote a granel en envasado y el volumen en litros a procesar</p>
            </div>
          </header>

          <div className="species-grid">
            <div className="custom-input-group">
              <select
                value={noLoteGranel}
                onChange={e => handleSelectGranel(e.target.value)}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px", fontWeight: 600 }}
              >
                <option value="">-- Seleccionar Lote a Granel en Envasado --</option>
                {(granelRecords || []).map((r, idx) => {
                  const fq = r.clave_fq || r.claveFQ || r.noAnalisis || r.noAnalisisFisicoquimico || r.no_analisis || "";
                  const maguey = r.tipoMaguey || r.especie || r.tipo_maguey || "";
                  const vol = r.invFinalVol !== undefined && r.invFinalVol !== "" ? r.invFinalVol : (r.litros || "");
                  return (
                    <option key={idx} value={r.noLote || r.id}>
                      {r.noLote || r.idContenedor} - {r.categoria || 'Mezcal'} ({r.clase || 'Blanco Joven'}){maguey ? ` [${maguey}]` : ''}{fq ? ` [FQ: ${fq}]` : ''} {vol ? `(Disponible: ${vol} L)` : ''}
                    </option>
                  );
                })}
                <option value="manual">➕ Ingreso manual / Otro lote no listado</option>
              </select>
              <label className="custom-input-label">Selector de Lote a Granel *</label>
            </div>

            <div className="custom-input-group">
              <input
                type="number"
                step="0.1"
                min="0"
                value={currentVolumenEnvasar}
                onChange={e => handleSetVolumenEnvasar(e.target.value)}
                className="custom-input-field"
                placeholder="Ej. 750"
                style={{ fontWeight: 700, color: "var(--agave-green)" }}
                required
              />
              <label className="custom-input-label">Volumen a Envasar (Litros) *</label>
              <span className="input-suffix">L</span>
            </div>
          </div>

          {noLoteGranel === "manual" && (
            <div className="custom-input-group" style={{ marginTop: 12 }}>
              <input
                type="text"
                value={noLoteGranel === "manual" ? "" : noLoteGranel}
                onChange={e => setNoLoteGranel(e.target.value)}
                className="custom-input-field"
                placeholder="Escriba el número de lote a granel..."
              />
              <label className="custom-input-label">Número de Lote a Granel Manual</label>
            </div>
          )}

          {/* DESPLIEGUE DE CARACTERÍSTICAS DEL LOTE A GRANEL EN ENVASADO */}
          <div style={{
            background: "linear-gradient(135deg, rgba(74, 93, 35, 0.08) 0%, rgba(16, 185, 129, 0.08) 100%)",
            border: "1px solid rgba(74, 93, 35, 0.25)",
            borderRadius: "10px",
            padding: "14px 16px",
            marginTop: "14px"
          }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px", borderBottom: "1px solid rgba(74, 93, 35, 0.15)", paddingBottom: "6px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <ScienceIcon style={{ color: "var(--agave-green)", fontSize: 18 }} />
                <strong style={{ color: "var(--agave-green)", fontSize: "13px", letterSpacing: "0.3px" }}>
                  Características del Lote a Granel en Envasado
                </strong>
              </div>
              <span className={`badge-status ${selectedGranel ? "aprobado" : "revision"}`} style={{ fontSize: "11px" }}>
                {selectedGranel ? "Lote Seleccionado" : "Esperando selección de granel"}
              </span>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "10px", fontSize: "12px" }}>
              <div>
                <span style={{ color: "var(--text-muted)", display: "block", fontSize: "11px" }}>Lote Granel Origen:</span>
                <strong style={{ color: "var(--text-main)" }}>{noLoteGranel || "Sin seleccionar"}</strong>
              </div>
              <div>
                <span style={{ color: "var(--text-muted)", display: "block", fontSize: "11px" }}>Categoría:</span>
                <strong style={{ color: "var(--text-main)" }}>{categoria || "-"}</strong>
              </div>
              <div>
                <span style={{ color: "var(--text-muted)", display: "block", fontSize: "11px" }}>Clase:</span>
                <strong style={{ color: "var(--text-main)" }}>{clase || "-"}</strong>
              </div>
              <div>
                <span style={{ color: "var(--text-muted)", display: "block", fontSize: "11px" }}>Tipo de Maguey:</span>
                <strong style={{ color: "var(--text-main)" }}>{tipoMaguey || "-"}</strong>
              </div>
              <div>
                <span style={{ color: "var(--text-muted)", display: "block", fontSize: "11px" }}>% Alc. Vol.:</span>
                <strong style={{ color: "var(--copper)" }}>{pctAlc ? `${pctAlc}%` : "-"}</strong>
              </div>
              <div>
                <span style={{ color: "var(--text-muted)", display: "block", fontSize: "11px" }}>Nº Análisis FQ:</span>
                <strong style={{ color: "var(--text-main)" }}>{noAnalisis || "-"}</strong>
              </div>
              <div>
                <span style={{ color: "var(--text-muted)", display: "block", fontSize: "11px" }}>Volumen Disponible Granel:</span>
                <strong style={{ color: "var(--agave-green)" }}>
                  {selectedGranel ? `${selectedGranel.invFinalVol || selectedGranel.litros || '-'} L` : "N/D"}
                </strong>
              </div>
              <div>
                <span style={{ color: "var(--text-muted)", display: "block", fontSize: "11px" }}>Ingrediente(s):</span>
                <strong style={{ color: "var(--text-main)" }}>{ingrediente || "100% Maguey"}</strong>
              </div>
            </div>
          </div>

          <div className="species-grid" style={{ marginTop: 14 }}>
            <div className="custom-input-group">
              <input
                type="date"
                value={fechaMovimiento}
                onChange={e => setFechaMovimiento(e.target.value)}
                className="custom-input-field"
              />
              <label className="custom-input-label">Fecha del Movimiento</label>
            </div>

            <div className="custom-input-group">
              <input
                type="text"
                value={loteEnvasado}
                onChange={e => setLoteEnvasado(e.target.value)}
                className="custom-input-field"
                placeholder="Ej. L-01-ENV-NT"
                style={{ fontWeight: 600 }}
              />
              <label className="custom-input-label">Lote de Envasado *</label>
            </div>
          </div>
        </section>

        {/* PASO 2: MARCA, INFORME DE APROBACIÓN DE ETIQUETA Y PRESENTACIÓN */}
        <section className="detail-card detail-card-accent-left-copper">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-copper">
              <LayersIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>2. Marca, Informe de Etiqueta y Presentación</h2>
              <p>Seleccione la marca comercial, número de aprobación de etiqueta y formato del envase</p>
            </div>
          </header>

          <div className="species-grid">
            <div className="custom-input-group">
              <input
                list="marcas-comerciales-list"
                type="text"
                value={marca}
                onChange={e => setMarca(e.target.value)}
                className="custom-input-field"
                placeholder="Seleccione o escriba la marca..."
                style={{ fontWeight: 600 }}
                required
              />
              <datalist id="marcas-comerciales-list">
                <option value="Don Julio Mezcal" />
                <option value="Mezcal Tradición Oaxaqueña" />
                <option value="Mezcal El Espadín Real" />
                <option value="Mezcal Ancestral San Baltazar" />
                <option value="Mezcal Los Danzantes" />
                <option value="Mezcal Alipús" />
              </datalist>
              <label className="custom-input-label">Marca Comercial *</label>
            </div>

            <div className="custom-input-group">
              <input
                list="informes-aprobacion-list"
                type="text"
                value={currentNoInformeAprobacion}
                onChange={e => handleSetNoInformeAprobacion(e.target.value)}
                className="custom-input-field"
                placeholder="Ej. INF-APR-ET-102"
                style={{ fontWeight: 600 }}
                required
              />
              <datalist id="informes-aprobacion-list">
                <option value="INF-APR-ET-102" />
                <option value="INF-APR-ET-105" />
                <option value="INF-APR-ET-2026-001" />
                <option value="INF-APR-ET-2026-002" />
              </datalist>
              <label className="custom-input-label">Inf. de Aprobación de Etiqueta *</label>
            </div>
          </div>

          <div className="species-grid" style={{ marginTop: 12 }}>
            <div className="custom-input-group">
              <select
                value={capacidad}
                onChange={e => setCapacidad(e.target.value)}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px", fontWeight: 600 }}
              >
                <option value="750 ml">750 ml (0.75 L)</option>
                <option value="700 ml">700 ml (0.70 L)</option>
                <option value="1000 ml">1000 ml / 1 L (1.00 L)</option>
                <option value="500 ml">500 ml (0.50 L)</option>
                <option value="375 ml">375 ml (0.375 L)</option>
                <option value="250 ml">250 ml (0.25 L)</option>
                <option value="200 ml">200 ml (0.20 L)</option>
                <option value="50 ml">50 ml (0.05 L)</option>
              </select>
              <label className="custom-input-label">Presentación (Capacidad) *</label>
            </div>

            <div className="custom-input-group">
              <select
                value={botCaja}
                onChange={e => setBotCaja(e.target.value)}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px" }}
              >
                <option value="12 botellas">12 botellas por caja</option>
                <option value="6 botellas">6 botellas por caja</option>
                <option value="24 botellas">24 botellas por caja</option>
                <option value="1 botella">1 botella (Sin caja / Sueltas)</option>
              </select>
              <label className="custom-input-label">Botellas por Caja (Bot/Caja)</label>
            </div>
          </div>
        </section>

        {/* PASO 3: MOVIMIENTOS E INVENTARIO CON CÁLCULO DE ENTRADAS */}
        <section className="detail-card detail-card-accent-left-copper">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-copper">
              <ShoppingBagIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>3. Inventario Inicial y Movimientos de Envasado</h2>
              <p>Entradas calculadas por fórmula (Volumen a envasar ÷ Presentación), saldo inicial y salidas</p>
            </div>
          </header>

          {/* BANNER INTERACTIVO DE CÁLCULO AUTOMÁTICO DE ENTRADAS */}
          <div style={{
            background: "linear-gradient(135deg, rgba(16, 185, 129, 0.12) 0%, rgba(5, 150, 105, 0.08) 100%)",
            border: "1.5px solid rgba(16, 185, 129, 0.4)",
            borderRadius: "10px",
            padding: "14px 16px",
            marginBottom: "16px",
            display: "flex",
            alignItems: "center",
            gap: "14px"
          }}>
            <ScienceIcon style={{ color: "#059669", fontSize: 32 }} />
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 800, color: "#065F46", fontSize: "13.5px" }}>
                Cálculo Automático de Entradas (Número de Botellas):
              </div>
              <div style={{ fontSize: "12.5px", color: "#047857", marginTop: "3px" }}>
                {currentVolumenEnvasar && capacidad ? (
                  <>
                    Volumen a envasar (<strong>{currentVolumenEnvasar} L</strong>) ÷ Presentación (<strong>{parseCapacityInLiters(capacidad)} L</strong> / {capacidad}) ={" "}
                    <span style={{ fontSize: "15px", fontWeight: 800, color: "#065F46", background: "rgba(16, 185, 129, 0.2)", padding: "2px 8px", borderRadius: "4px" }}>
                      {entradaBotellas || 0} botellas
                    </span>
                    {" "}(aprox. <strong>{entradaCajas || 0} cajas</strong> de {botCaja})
                  </>
                ) : (
                  "Seleccione lote a granel, indique volumen y presentación para calcular automáticamente las botellas de entrada."
                )}
              </div>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="number"
                value={entradaBotellas}
                onChange={e => setEntradaBotellas(e.target.value)}
                className="custom-input-field"
                style={{ fontWeight: 700, color: "var(--agave-green)" }}
                required
              />
              <label className="custom-input-label">Botellas Entrada (Calculado) *</label>
            </div>

            <div className="custom-input-group">
              <input
                type="number"
                value={entradaCajas}
                onChange={e => setEntradaCajas(e.target.value)}
                className="custom-input-field"
                style={{ fontWeight: 700 }}
              />
              <label className="custom-input-label">Cajas Entrada (Calculado)</label>
            </div>
          </div>

          <div className="custom-input-group" style={{ marginTop: 12 }}>
            <input
              type="text"
              value={entradaProcedencia}
              onChange={e => setEntradaProcedencia(e.target.value)}
              className="custom-input-field"
              placeholder="Ej. Línea de Envasado 1"
            />
            <label className="custom-input-label">Procedencia de Entrada</label>
          </div>

          <hr style={{ border: 0, borderBottom: "1px solid var(--glass-border)", margin: "18px 0" }} />

          <div className="species-grid">
            <div className="custom-input-group">
              <input
                type="number"
                value={invInicialCajas}
                onChange={e => setInvInicialCajas(e.target.value)}
                className="custom-input-field"
              />
              <label className="custom-input-label">Cajas Iniciales</label>
            </div>

            <div className="custom-input-group">
              <input
                type="number"
                value={invInicialBotellas}
                onChange={e => setInvInicialBotellas(e.target.value)}
                className="custom-input-field"
              />
              <label className="custom-input-label">Botellas Iniciales</label>
            </div>
          </div>

          <div className="species-grid" style={{ marginTop: 12 }}>
            <div className="custom-input-group">
              <input
                type="number"
                value={salidaCajas}
                onChange={e => setSalidaCajas(e.target.value)}
                className="custom-input-field"
              />
              <label className="custom-input-label">Cajas Salida</label>
            </div>

            <div className="custom-input-group">
              <input
                type="number"
                value={salidaBotellas}
                onChange={e => setSalidaBotellas(e.target.value)}
                className="custom-input-field"
              />
              <label className="custom-input-label">Botellas Salida</label>
            </div>
          </div>

          <div className="custom-input-group" style={{ marginTop: 12 }}>
            <input
              type="text"
              value={salidaDestino}
              onChange={e => setSalidaDestino(e.target.value)}
              className="custom-input-field"
              placeholder="Ej. Área de Etiquetado y Hologramas"
            />
            <label className="custom-input-label">Destino de Salida</label>
          </div>

          <div className="custom-input-group" style={{ marginTop: 12 }}>
            <input
              type="text"
              value={mermas}
              onChange={e => setMermas(e.target.value)}
              className="custom-input-field"
              placeholder="Ej. 2 botellas (rotura en línea)"
            />
            <label className="custom-input-label">Mermas (Botellas dañadas)</label>
          </div>
        </section>

        {/* PASO 4: INVENTARIO FINAL CALCULADO Y OBSERVACIONES */}
        <section className="detail-card detail-card-accent-left-green" style={{ gridColumn: "1 / -1" }}>
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <CheckCircleIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>4. Inventario Final Calculado y Observaciones</h2>
              <p>Saldo final de botellas desnudas sin etiquetar disponibles en inventario</p>
            </div>
          </header>

          <div className="species-grid" style={{ marginTop: 12 }}>
            <div className="custom-input-group">
              <input
                type="number"
                value={calcFinalCajas}
                readOnly
                className="custom-input-field"
                style={{ opacity: 0.9, fontWeight: 700, color: "var(--agave-green)" }}
              />
              <label className="custom-input-label">Nº Cajas Finales (Calculado)</label>
            </div>

            <div className="custom-input-group">
              <input
                type="number"
                value={calcFinalBotellas}
                readOnly
                className="custom-input-field"
                style={{ opacity: 0.9, fontWeight: 700, color: "var(--agave-green)" }}
              />
              <label className="custom-input-label">Nº Botellas Finales (Calculado)</label>
            </div>
          </div>

          <div className="custom-input-group" style={{ marginTop: 20 }}>
            <textarea
              value={observaciones}
              onChange={e => setObservaciones(e.target.value)}
              className="custom-input-field"
              style={{ height: "80px", resize: "none", padding: "14px" }}
              placeholder="Notas generales sobre el lote de envasado no terminado..."
            />
            <label className="custom-input-label">Observaciones</label>
          </div>
        </section>

              {/* Footer de Acciones del Modal */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: "12px", borderTop: "1px solid #E2E8F0" }}>
                <button
                  type="button"
                  onClick={() => setIsFormOpen(false)}
                  className="btn-cancel-modal"
                >
                  Cancelar
                </button>

                <div style={{ display: "flex", gap: "10px" }}>
                  <button
                    type="button"
                    onClick={() => handleSaveNoTerminado("borrador")}
                    className="btn-cancel-modal"
                    style={{ background: "#F1F5F9", color: "#475569", border: "1px solid #CBD5E1", fontWeight: 700 }}
                  >
                    Guardar Borrador
                  </button>

                  <button
                    type="submit"
                    className="destilacion-btn-new"
                    style={{ background: "linear-gradient(135deg, #059669 0%, #10B981 100%)", boxShadow: "0 4px 14px rgba(5, 150, 105, 0.3)" }}
                  >
                    <CheckCircleIcon style={{ fontSize: 18 }} />
                    <span>Guardar Registro de Envasado de Producto</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default EnvasadoNoTerminadoSection;
